import React, { useState } from 'react';
import {
  IconButton,
  Typography,
  Grid,
  Paper,
  Button
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { makeStyles } from '@material-ui/core/styles'
import { cashBookTransServerSideCols, cashBookDistribCols, apPaymentCols, cashBookCbCheckCols } from '../constants/CashCodeCols'
import { smallScreenWidth } from '../constants/AppConstants'
import ServerSideAutoCompletev2 from '../functions/ServerSideAutoCompletev2'
import DateInput from '../components/DateInput'
import LoadingButton from '../components/LoadingButton'
import LoadingLink from '../components/LoadingLink.js'
import ReactTableServerSide from '../components/ReactTableServerSide'
import LambdaFetch from '../functions/FetchFromLambda'
import DialogTable from '../components/DialogTable'
import { useCashBookTransServerSideCols } from '../hooks/CashCodeCols';
import { DashboardAthenaTableServerSide } from '../components/DashboardAthenaTableServerSide'
import fetchFromAthena from '../functions/FetchFromAthena'
import { DashboardAthenaTable } from '../components/DashboardAthenaTable'
import { DashboardAthenaTableServerSideNoSelect } from '../components/DashboardAthenaTableServerSideNoSelect'
import OpenSearchDropdown from '../components/OpenSearchDropdown'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem',
  },
  paper: {
    padding: theme.spacing(2),
    color: 'rgba(0,0,0,0.9)',
    height: '100%',
  },
  descript: { fontSize: '0.8rem', color: '#545454' },
  descriptVal: { fontSize: '0.85rem' },
}));

const defaultHeaders = {
  transNbr: '',
  cashCode: '',
  bankCode: '',
  fromDate: '',
  toDate: '',
};

export default function CashBookTrans(props) {
  const classes = useStyles();
  const { credentials } = props.fetchInitialData;
  const [state, setstate] = useState({
    cbTransData: null,
    selectedAsset: '',
    selectedCompany: '',
    assetData: null,
    isLoading: false,
    tableKey: JSON.stringify(defaultHeaders)
  })
  const [headers, setHeaders] = useState(defaultHeaders)
  const [transNbr, setTransNbr] = React.useState('')
  const [showTable, setShowTable] = useState(false)
  const [distrib, setDistrib] = useState(null)
  const [apPayment, setApPayment] = useState(null)
  const [cbCheck, setCbCheck] = useState(null)
  const [clearHeader, setClearHeader] = React.useState(false)
  const [clearTrigger, setClearTrigger] = React.useState(false)

  const cashBookTransServerSideCols = useCashBookTransServerSideCols();

  const handleSubmitTrans = (e) => {
    e.preventDefault();

    if (!headers.transNbr && !(headers.cashCode && headers.bankCode)) {
      props.fetchInitialData.createSnack(
        'Please enter a Payment or Cash Code AND Payment Type',
        'warning',
        3000
      );
      return null;
    }
    if (JSON.stringify(headers) === state.tableKey) return null
    setShowTable(true)
    setstate({ ...state, isLoading: true, tableKey: JSON.stringify(headers) })
  }
  const getDistribData = async (code, id) => {
    try {
      // const resp = await LambdaFetch(
      //   'cash-book',
      //   'post',
      //   credentials.user.accessToken,
      //   JSON.stringify({
      //     action: 'cb-distrib-read',
      //     instCode: code,
      //     transId: id
      //   }),
      //   '',
      //   credentials
      // )
      // setDistrib(resp.data.cbDistrib)


      const data = await fetchFromAthena({
        queryName: 'cb_distrib_read',
        headers: {
          instCode: code,
          transId: id
        },
        accessToken: credentials.user.accessToken,
        credentials: credentials
      })

      setDistrib(data)
    } catch (e) {
      console.log(e)
    }
  }

  const getApPaymentData = async (group, code, id) => {
    try {
      // const resp = await LambdaFetch(
      //   'cash-book',
      //   'post',
      //   credentials.user.accessToken,
      //   JSON.stringify({
      //     action: 'ap-payment-read',
      //     payGroup: group,
      //     instCode: code,
      //     transId: id
      //   }),
      //   '',
      //   credentials
      // )
      // setApPayment(resp.data.apPayment)

      const data = await fetchFromAthena({
        queryName: 'ap_payment_from_cb_read',
        headers: {
          payGroup: group,
          instCode: code,
          transId: id
        },
        accessToken: credentials.user.accessToken,
        credentials: credentials
      })
      setApPayment(data)
    } catch (e) {
      console.log(e)
    }
  }

  const getCbCheckData = async (row) => {
    try {
      const data = await fetchFromAthena({
        queryName: 'cashbook_trans_cbcheck',
        headers: {
          serialNum: String(row.TRANS_NBR || '').trim().replace(/^0+(?=\d)/, ''),
          payGroup: row.PAY_GROUP,
          cashCode: row.CASH_CODE,
          instCode: row.BANK_INST_CODE
        },
        accessToken: credentials.user.accessToken,
        credentials: credentials
      })
      setCbCheck(data)
    } catch (e) {
      console.log(e)
    }
  }

  const tableDataTransformation = (rows) => {
    return rows.map((row, index) => {
      const handleViewClick = async () => {
        if (row.SOURCE_CODE === 'AP') {
          await getApPaymentData(row.PAY_GROUP, row.BANK_INST_CODE, row.TRANS_IDENT);
        } else {
          await getDistribData(row.BANK_INST_CODE, row.TRANS_IDENT);
        }
      };

      return {
        ...row,
        VIEW_DISTRIB: (
          <LoadingLink onClick={handleViewClick}>
            view
          </LoadingLink>
        ),
        VIEW_CB_CHECK: (
          <LoadingLink onClick={() => getCbCheckData(row)}>
            view
          </LoadingLink>
        )
      };
    });
  };
  const handleCallback = (values, error) => {
    if (error) {
      setstate({ ...state, isLoading: false });
      setShowTable(false);
      return null;
    }
    setstate({ ...state, isLoading: false });
  };
  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size="small"
        onClick={() => props.history.push('/')}
        aria-label="delete"
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant="h5" style={{ textAlign: 'center' }}>
        Cash Book Trans (CB80)
      </Typography>

      <DialogTable
        isOpen={!!apPayment}
        handleClose={() => setApPayment(null)}
        tableData={apPayment}
        cols={apPaymentCols}
        fileName={`apPayment`}
        noFooter
      />
      <DialogTable
        isOpen={!!distrib}
        handleClose={() => setDistrib(null)}
        tableData={distrib}
        cols={cashBookDistribCols}
        fileName={`distrib`}
        noFooter
      />
      <DialogTable
        isOpen={!!cbCheck}
        handleClose={() => setCbCheck(null)}
        tableData={cbCheck}
        cols={cashBookCbCheckCols}
        fileName={`cbCheck`}
        noFooter
      />

      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={handleSubmitTrans}>
            <Grid
              container
              alignContent="center"
              alignItems="flex-start"
              spacing={2}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='transNbr'
                  required={false}
                  width='200px'
                  label='Payment'
                  page="CASHBOOK"
                  entity="PAYMENT"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, transNbr: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <Typography style={{ marginTop: '46px' }} variant="body1">
                  OR
                </Typography>
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='cashCode'
                  required={false}
                  width='220px'
                  label='Cash Code'
                  page="CASHBOOK"
                  entity="CASHCODE"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, cashCode: val?.VALUE || null })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='bankInstCode'
                  required={false}
                  width='220px'
                  label='Payment Type'
                  page="CASHBOOK"
                  entity="PAYMENTTYPE"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, bankCode: val?.VALUE || null })
                  }}
                />
              </Grid>
              {[
                {
                  id: 'fromDate',
                  label: 'From Date',
                },
                {
                  id: 'toDate',
                  label: 'To Date',
                },
              ].map((field) => {
                return (
                  <Grid key={field.id} item>
                    <DateInput
                      id={field.id}
                      key={`${field.id}-${clearHeader}`}
                      type={'date'}
                      required={false}
                      label={field.label}
                      value={headers[field.id]}
                      onChange={(e) => {
                        setHeaders({
                          ...headers,
                          [field.id]: !!e.target.value ? e.target.value : null,
                        });
                      }}
                      variant="standard"
                      width="160px"
                    />
                  </Grid>
                );
              })}
            </Grid>

            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label="Submit"
                isLoading={state.isLoading}
                color="primaryVLButton"
                buttonType="submit"
              />
              {!!Object.values(headers).some(value => value !== '' && value !== null) && (
                <Button
                  onClick={() => {
                    setClearHeader(!clearHeader)
                    setHeaders(defaultHeaders)
                    setClearTrigger(prev => !prev)
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>


        {showTable && (
          <div style={{ marginTop: '1rem ' }}>
            <DashboardAthenaTable
              {...props}
              isTempTable={true}
              key={state.tableKey}
              params={{ ...headers }}
              transform={tableDataTransformation}
              tableColumns={cashBookTransServerSideCols}
              reportParamName="cashbook_trans_serverside"
              reportName='cashbook_trans_serverside_temp'
              tableTitle={''}
              callback={handleCallback}
              downloadFileName={'Cash_Book_Download'}
            />
          </div>
        )}
      </div>
    </div>
  );
}
